import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { GET_IS_UNIQUE_ORG_NAME_PATH, get_organization_by_name_path } from 'ze-api-contract/organization-v2/get-is-unique-org-name';
import { GET_ORGANIZATION_UNIQUE_NAME_PATH, get_organization_uniquer_name_path } from 'ze-api-contract/organization-v2/get-organization-unique-name';
// Internal query keys, not exported from barrel file
const organizationUniqueNameQuery = createQueryKeys('organization', {
    getUniqueName: (displayName)=>({
            queryKey: [
                GET_ORGANIZATION_UNIQUE_NAME_PATH,
                displayName
            ],
            queryFn: async ()=>{
                if (!displayName) {
                    return;
                }
                return axios.get(get_organization_uniquer_name_path({
                    displayName
                })).then((res)=>res.data.value);
            }
        }),
    getIsUniqueOrgName: (name)=>({
            queryKey: [
                GET_IS_UNIQUE_ORG_NAME_PATH,
                name
            ],
            queryFn: async ()=>{
                if (!name) {
                    return false;
                }
                return axios.get(get_organization_by_name_path({
                    name
                })).then((res)=>res.data.value);
            }
        })
});
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export async function getUniqueOrganizationName(queryClient, displayName) {
    return queryClient.fetchQuery(organizationUniqueNameQuery.getUniqueName(displayName));
}
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export async function useGetIsUniqueOrganizationName(queryClient, name) {
    return queryClient.fetchQuery(organizationUniqueNameQuery.getIsUniqueOrgName(name));
}
